import React, { useState } from 'react'
import { UserContextProvider } from '../context/UserContext'
import Layout from '../components/Layout'
import { toast } from 'react-toastify'
import { createVideo } from '../services/video.service'
import { useNavigate } from 'react-router-dom'
import VideoForm from '../sections/VideoForm'

const CreateVideo = () => {
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const onSubmit = async (e) => {
    try {
      setIsLoading(true)
      e.preventDefault()
      const data = new FormData(e.target)
      await createVideo({ form: data })
      toast.success('Berhasil menambahkan video')
      navigate('/konten/video')
    } catch (error) {
      toast.error(error?.response?.data?.error?.message ?? 'Error')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <UserContextProvider>
      <Layout
        activeNav="Video"
        isBackButtonShown={true}
        isPreviewShown={true}
        previewComponent={
          <div>
            <p className="font-semibold text-[28px] my-2">Preview</p>
            <img
              src={
                'https://nos.wjv-1.neo.id/jakmania-bucket/assets/Tutor%20CMS/Video/Video-x3.png'
              }
              className="object-contain mx-auto w-[210px] h-[480px] mb-4"
            />
            <p className="font-normal text-[16px]">Deskripsi</p>
            <p className="opacity-70 text-[14px] mb-4">
              Perubahan pada video akan mempengaruhi bagian Jakmania Spotlight,
              video yang kamu upload nanti akan masuk ke aplikasi the Jakmania.
            </p>
            <p className="font-normal text-[16px]">Urutan</p>
            <p className="opacity-70 text-[14px] mb-4">
              Urutan video akan menentukan letak video pada aplikasi
            </p>
            <p className="font-normal text-[16px]">Video Url</p>
            <p className="opacity-70 text-[14px] mb-4">
              Masukkan video kedalam youtube, dsb. Kemudian copy tautan video
              dan masukkan kedalam CMS untuk di-upload ke aplikasi.
            </p>
          </div>
        }
      >
        <VideoForm onSubmit={onSubmit} isLoading={isLoading} />
      </Layout>
    </UserContextProvider>
  )
}

export default CreateVideo
